import Form from '../components/Form.js'
import global from '../utils/global.js'
import Page from './Page.js'

export default class BookingPage extends Page {

    static instance

    constructor(parent) {

        if ( BookingPage.instance ) return BookingPage.instance
        super( 'booking' )
        BookingPage.instance = this
        this.parent = parent
        global.views.push( this.view )

        
    }   

    afterEnter({next}){

        const formElement = next.container.querySelector(".booking_form")
        
        if(formElement){
            this.bookingForm = new Form(formElement,this)
        }

        console.log(this.bookingForm)
    }

    afterLeave(){

        if(this.bookingForm){
            this.bookingForm.destroy()
            this.bookingForm = null
        }

    }

}
